<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">

            <router-link to="/addvalidationQueue" class=" btn btn-success transition border-0 lh-1 fw-medium">
                + Ajouter une Validation Queue </router-link>
            <div class="d-flex align-items-center">
                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher une validation queue" />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Code
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Libellé de la file
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Description
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Niveau de risque minimal
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Niveau de risque maximal
                            </th>
                           
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Pays
                            </th>
                             <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Port
                            </th>
                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                                Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(validationQueue, index) in validationQueues" :key="index">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationQueue?.code }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationQueue?.name }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationQueue?.description }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getRiskDisplay(validationQueue?.minRiskLevel)"></span>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getRiskDisplay(validationQueue?.maxRiskLevel)"></span>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationQueue?.pays?.iso2_code }} {{ validationQueue?.pays?.iso3_code }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationQueue?.port?.nomPort }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                                <div class="dropdown">
                                    <span class="badge text-white bg-primary fs-15 dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Actions
                                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                                    </span>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <router-link
                                                :to="{ name: 'EditValidationQueuePage', params: { id: validationQueue.id } }"
                                                class="dropdown-item d-flex align-items-center"><i
                                                    class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier</router-link>
                                        </li>
                                        <li>
                                            <a href="#" class="dropdown-item d-flex align-items-center"
                                                @click.prevent="openAffectation(validationQueue)">
                                                <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                                                Affecter
                                            </a>
                                        </li>

                                        <li>
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);"
                                                @click="suppression(validationQueue.id, validationQueue, 'validationq', 'validationQueue')">
                                                <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                                                Supprimer
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
                    @paginate="handlePaginate" />

            </div>
        </div>
    </div>
    <Affectation v-if="selectedValidationQueue" :validationQueue="selectedValidationQueue"
        :key="selectedValidationQueue.id" @refresh="getAllValidationQueue" />

</template>
<script lang="ts">

import { defineComponent, onMounted, ref, watch, computed, nextTick } from "vue";

import ApiService from "../../services/ApiService";
import { format_date, suppression, error } from "../../utils/utils";
import axios from 'axios';
import Swal from "sweetalert2";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import { TypeFretPaiement } from "@/models/TypeFretPaiement";

import { ValidationQueues } from "@/models/ValidationTask";
import AddModalValidationQueue from "./AddModalValidationQueue.vue";
import Affectation from "../Affectation/Affectation.vue";
import { Modal } from "bootstrap";

export default defineComponent({
    name: "ListeValidationQueue",
    components: {
        PaginationComponent,
        Affectation
    },
    setup: () => {
        const validationQueues = ref<Array<ValidationQueues>>([]);
        const validationQueue = ref<ValidationQueues>();
        const addModalValidationQueueRef = ref<null | HTMLElement>(null);
        const selectedItem = ref(0);
       const selectedValidationQueue = ref<ValidationQueues>({} as ValidationQueues);

        const openAffectation = (queue) => {
            selectedValidationQueue.value = queue

            nextTick(() => {
                const el = document.getElementById('AddModalAffectation')
                if (!el) return
                new Modal(el).show()
            })
        }


        // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
            try {
                page.value = page_;
                getAllValidationQueue(page_, limit_);
            } catch (error) {
                //
            }
        };

        function rechercher() {
            getAllValidationQueue(page.value, limit.value, searchTerm.value);
        }

        // END PAGINATE

        function getAllValidationQueue(page = 1, limi = 10, searchTerm = '') {
            // const user = JwtService.getUser();
            // console.log("user:", user);
            // if (!user) return error("Utilisateur non connecté");
            // const userId = user.userId.replace(/\/+$/, '').trim();
            // if (!userId) return error("Utilisateur non connecté");
            return ApiService.get(`validationqsss?page=${page}&limit=${limi}&searchTerm=${searchTerm}&`)
                .then(({ data }) => {
                    validationQueues.value = data.data.data;
                    console.log("vq",  validationQueues.value )
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                })
                .catch(({ response }) => {
                    error(response.data.message)
                });
        }

        onMounted(() => {
            getAllValidationQueue();
        });


        const getRiskDisplay = (value: string | null | undefined): string => {
            if (!value) return '<span class="badge bg-secondary">Aucun</span>';

            switch (value) {
                case 'LOW':
                    return '<span class="badge bg-success text-white">Faible</span>';
                case 'MEDIUM':
                    return '<span class="badge bg-warning text-dark">Moyen</span>';  // text-dark pour lisibilité sur fond jaune/orange
                case 'HIGH':
                    return '<span class="badge bg-danger text-white">Élevé</span>';
                default:
                    return '<span class="badge bg-secondary text-white">' + value + '</span>';
            }
        };

        const privileges = ref<Array<string>>(JwtService.getPrivilege());

        const checkPermission = (name) => {
            return privileges.value.includes(name);
        }
        return {
            // modules,
            checkPermission,
            selectedItem,
            validationQueues,
            getRiskDisplay,
            suppression,
            page,
            totalPages,
            limit,
            totalElements,
            getAllValidationQueue,
            handlePaginate,
            searchTerm,
            rechercher, addModalValidationQueueRef,
            openAffectation,
            selectedValidationQueue,
        };
    },
});
</script>
